<template>
  <div
    ref="popper"
    :class="[
      `${prefix}tooltip`,
      `${prefix}fade`,
      {
        'mpx-show': showTooltip
      }
    ]"
  >
    <div :class="[
      `${prefix}tooltip-inner`,
      `${prefix}text-justify`
    ]">
      <slot>{{ content }}</slot>
    </div>
  </div>
</template>

<script>
import { createPopper } from '@popperjs/core';

export default {
  name: 'MpxTooltip',
  props: {
    prefix: {
      type: String,
      default: 'mpx-',
    },
    trigger: {
      type: String,
      default: 'click',
    },
    placement: {
      type: String,
      default: 'top',
    },
    content: {
      type: String,
      default: null,
    },
    target: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    showTooltip: false,
    popperInstance: null,
  }),
  watch: {
    showTooltip(val) {
      this.$nextTick(() => {
        if (val && this.getTriggerElement) {
          this.resetPopperInstance();
        }
      });
    },
  },
  computed: {
    getTriggerElement() {
      return this.target ? document.querySelector(`#${this.target}`) : null;
    },
  },
  mounted() {
    if (this.getTriggerElement) {
      if (this.trigger === 'click') {
        this.getTriggerElement.addEventListener('click', this.handleClick);
      } else {
        this.getTriggerElement.addEventListener('mouseenter', this.activateTooltip);
        this.getTriggerElement.addEventListener('mouseleave', this.hideTooltip);
      }
      this.getTriggerElement.addEventListener('focus', this.activateTooltip);
      this.getTriggerElement.addEventListener('blur', this.hideTooltip);
    }
  },
  beforeDestroy() {
    if (this.getTriggerElement) {
      if (this.trigger === 'click') {
        this.getTriggerElement.removeEventListener('click', this.handleClick);
      } else {
        this.getTriggerElement.removeEventListener('mouseenter', this.activateTooltip);
        this.getTriggerElement.removeEventListener('mouseleave', this.hideTooltip);
      }
      this.getTriggerElement.removeEventListener('focus', this.activateTooltip);
      this.getTriggerElement.removeEventListener('blur', this.hideTooltip);
    }
  },
  methods: {
    handleClick(e) {
      if (document.activeElement !== e.target) {
        this.showTooltip = !this.showTooltip;
      }
    },
    activateTooltip() {
      this.showTooltip = true;
    },
    hideTooltip(e) {
      if (document.activeElement !== e.target) {
        this.showTooltip = false;
      }
    },
    resetPopperInstance() {
      if (this.popperInstance) {
        this.popperInstance.destroy();
        this.popperInstance = null;
      }
      const tooltipDistance = 8;
      this.popperInstance = createPopper(this.getTriggerElement, this.$refs.popper, {
        placement: this.placement,
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, tooltipDistance],
            },
          },
        ],
      });
    },
  },
};
</script>
